import React from 'react';
import useUserStore from '../../store/userStore';
import EmailTemplatesTab from '../SettingsPage/components/email/EmailTemplatesTab';

/**
 * «Plantillas de correo» de la empresa: lo que dice cada correo (asunto, cuerpo,
 * botones y marca). Cuándo sale y en qué orden está en «Configuración»
 * (`EmailSchedule`, en /ar-arranque).
 *
 * Es **la misma pantalla que usa ClaimUp** en `/settings` → Email · Resend, con
 * `esCliente`. No es una copia: duplicarla garantizaría que en seis meses una de
 * las dos tuviera un campo que la otra no, y nadie sabría cuál manda.
 *
 * ── Por qué no hay propuesta ni aprobación ──────────────────────────────────
 * En WhatsApp (`/ar-templates`) la empresa **propone** y ClaimUp revisa, porque
 * **Meta tiene que aprobar** cada plantilla antes de poder usarla. En correo no
 * hay nadie que apruebe nada: lo que escriba sale tal cual. Montar aquí una
 * revisión sería inventarse un trámite que el canal no pide.
 *
 * El cortafuegos es otro y ya existe: la **pausa automática por reputación**. Si
 * sus correos empiezan a rebotar o a generar quejas, el sistema le corta el
 * envío solo y ClaimUp lo ve en su panel.
 *
 * ⚠️ Lo que ese cortafuegos NO cubre: **Resend suprime direcciones a nivel de
 * CUENTA, no de dominio**. Un cliente que genere muchas quejas puede ir
 * bloqueando destinatarios de los demás clientes de AR. Con pocos clientes es
 * asumible; antes de que sean muchos hay que decidir entre revisión previa o
 * cuentas de Resend separadas. Está en `docs/email-ar-resend-plan.md`.
 *
 * Es la pestaña Correo de «Plantillas» (`PlantillasPage`): el marco de la
 * página lo pone ella.
 */
const ArEmailPage = () => {
  const user = useUserStore(state => state.user);

  // La pantalla es de la empresa, así que la única empresa es ella. Se le pasa
  // en el mismo formato que usa el admin —[id, nombre]— para que el componente
  // no tenga que saber quién lo está mirando.
  //
  // Su propio id va en la URL de las llamadas, y no hace falta un endpoint
  // «/my/» aparte: `canManageCompanyEmail` ya exige que el id de la URL sea el
  // suyo, así que la puerta es la misma y no hay siete rutas duplicadas que
  // mantener en paralelo.
  const empresas = [[user?.id, [user?.name, user?.lastName].filter(Boolean).join(' ') || 'Tu empresa']];

  return (
    <>
      <p className='text-sm text-slate-500 mb-4'>
        Lo que dicen los correos a tus deudores. Salen desde tu propio dominio, con tu nombre.
      </p>
      <EmailTemplatesTab empresas={empresas} esCliente soloTextos />
    </>
  );
};

export default ArEmailPage;
